const FieldLabelWrapper = ({
  errorMessage = null,
  className = "",
  name,
  label,
  children,
}: {
  errorMessage?: any;
  className?: string;
  name: string;
  label: string;
  children?: React.ReactNode;
}) => (
  <div
    className={className || "unchained-form-field__label"}
    aria-errormessage={
      typeof errorMessage === "string" ? errorMessage : undefined
    }
    aria-invalid={!!errorMessage}
    data-error-wrapper-for={name}
  >
    <label htmlFor={name}>{label}</label>
    {children}
  </div>
);

export default FieldLabelWrapper;
